import React, { useContext, useEffect } from "react";
import { motion } from "framer-motion";
import AnimationContext from "../contexts/animation/AnimationContext";
const Skill = ({ name, url, inView }) => {
  const { setAnimation } = useContext(AnimationContext);
  const inViewVariants = setAnimation(inView);
  return (
    <motion.div
      variants={inViewVariants}
      initial="hidden"
      animate="visible"
      className="flex justify-center items-center flex-col gap-2"
    >
      <img src={`${url}`} alt={name} className="w-full h-full object-cover" />
      <h4 className=" text-light text-sm sm:text-lg font-bold">{name}</h4>
    </motion.div>
  );
};

export default Skill;
